import type { Directive } from 'vue'

const autofocus: Directive = {
  mounted(el, { value }) {
    if (value) {
      el.focus()
    }
  },
}

export default autofocus
